export default "__VITE_ASSET__VT0OghXn__"